import FilterModel from 'app/components/FilterModel';
import PageLoader from 'app/components/PageLoader';
import PaginatedTable from 'app/components/table/PaginationTable';
import { slabBifurcationHeader } from 'app/constants/table-header-constants';
import useSlabBifurcationReport from './useSlabBifucationReport';

const SlabBifurcationReport = () => {
  const {
    pageLoading,
    filteredData,
    paginationHandler,
    navigate,
    totalNumber,
    currentPage,
    dataPerPage,
    pageCount,
    sectionObj,
    isFilterOpen,
    setIsFilterOpen,
    values,
    setValues,
    resetfilterModel,
    handleSubmit,
    handleFilterCancel,
    fetchReportData,
    isFiltering,
  } = useSlabBifurcationReport();

  return (
    <>
      <div className='cms-content__container'>
        <div className='cms-content__container billmanagement'>
          <PaginatedTable
            fulldata={filteredData}
            sectionObj={sectionObj}
            columns={slabBifurcationHeader}
            data={filteredData}
            currentPage={currentPage}
            dataPerPage={dataPerPage}
            pageCountNumber={pageCount}
            totalNumber={totalNumber}
            pageLoading={pageLoading}
            navigate={navigate}
            isLoading={pageLoading}
            paginationHandler={paginationHandler}
            fetchData={fetchReportData}
            isFiltering={isFiltering}
            values={values}
          />
        </div>
        {isFilterOpen && (
          <FilterModel
            isFilterOpen={isFilterOpen}
            setIsFilterOpen={setIsFilterOpen}
            onSubmit={handleSubmit}
            onCancel={handleFilterCancel}
            values={values}
            setValues={setValues}
            resetfilter={resetfilterModel}
          >
            <>
              <label>First Bill Date ranges:</label>
              <div className='offcanvas-item'>
                <label>Start Date</label>
                <input
                  type='date'
                  value={values?.startDate}
                  max={values?.endDate}
                  onChange={(e) =>
                    setValues({
                      ...values,
                      startDate: e.target.value,
                    })
                  }
                />
              </div>
              <div className='offcanvas-item'>
                <label>End Date</label>
                <input
                  type='date'
                  value={values?.endDate}
                  min={values?.startDate}
                  onChange={(e) =>
                    setValues({
                      ...values,
                      endDate: e.target.value,
                    })
                  }
                />
              </div>
            </>
          </FilterModel>
        )}
      </div>
      {pageLoading === true && <PageLoader pageLoading={pageLoading} />}
    </>
  );
};

export default SlabBifurcationReport;
